export default __webpack_public_path__ + "static/media/bdl.548cfd60.svg";